/// <reference path="../modules/blocks.exception.module.ts"/>

module Blocks {
    export interface IExceptionHandlerProvider extends ng.IServiceProvider {
        config: { configuratorErrorPrefix: any; };
        configure(configuratorErrorPrefix: any): void;
    }

    export class ExceptionHandlerProvider implements IExceptionHandlerProvider {
        static providerId: string = "exceptionHandler";

        config = { configuratorErrorPrefix: undefined };

        configure = (configuratorErrorPrefix: any) => {
            this.config.configuratorErrorPrefix = configuratorErrorPrefix;
        };

        $get = () => {
            return { config: this.config };
        };
    }

    export function config($provide) {
        $provide.decorator('$exceptionHandler', extendExceptionHandler);
    }

    export function extendExceptionHandler($delegate, exceptionHandler, logger) {
        return (exception, cause) => {
            var configuratorErrorPrefix = exceptionHandler.config.configuratorErrorPrefix || '';
            var errorData = { exception: exception, cause: cause };
            exception.message = configuratorErrorPrefix + exception.message;
            $delegate(exception, cause);
            /**
             * Could add the error to a service's collection,
             * add errors to $rootScope, log errors to remote web server,
             * or log locally. Or throw hard. It is entirely up to you.
             * throw exception;
             *
             * @example
             *     throw { message: 'error message we added' };
             */
            logger.error(exception.message, errorData);
        };
    }

    exception.provider(ExceptionHandlerProvider.providerId, ExceptionHandlerProvider)
        .config(config);
}